'use strict';

/**
 * @param {*} any
 * @returns {*}
 */
export function identity(any) {
  return any;
}
/**
 * @param {HTMLElement} element
 * @param {String} className
 */
export function addClass(element, className) {
  if (!className) return;
  if (element.classList) {
    element.classList.add(className);
  } else {
    let list = element.className.split('\s+');
    list = list.filter(clsName => clsName !== className);
    list.push(className);
    element.className = list.join(' ');
  }
}
/**
 * @param {HTMLElement} element
 * @param {String} className
 */
export function removeClass(element, className) {
  if (!className) return;
  if (element.classList) {
    element.classList.remove(className);
  } else {
    let list = element.className.split('\s+');
    list = list.filter(clsName => clsName !== className);
    element.className = list.join(' ');
  }
}
/**
 * @see http://learn.javascript.ru/coordinates-document#getCoords 
 * @param {HTMLElement} element
 * @returns {Object}
 */
export function getOffset(element) {
  let box = element.getBoundingClientRect();
  return {
    top: box.top + window.pageYOffset,
    left: box.left + window.pageXOffset,
    bottom: box.bottom + window.pageYOffset,
    right: box.right + window.pageXOffset
  };
}
/**
 * @param {HTMLElement} element
 * @returns {Object}
 */
export function getPosition(element) {
  let parentElement = element.parentNode;
  let offset = getOffset(element);
  let parentOffset = getOffset(parentElement);
  let width = offset.right - offset.left; 
  let height = offset.bottom - offset.top;
  let top = offset.top - parentOffset.top;
  let left = offset.left - parentOffset.left;
  return {
    top,
    left,
    bottom: top + height,
    right: left + width
  }
}
/**
 * @param {HTMLElement} element
 * @returns {Object}
 */
export function getSize(element) {
  let {top,left,bottom,right} = getOffset(element);
  let width = right - left;
  let height = bottom - top;
  return {
    width,
    height
  };
}


// WEBPACK FOOTER //
// ./src/js/lang.js